{
  "Untitled event": "無題のイベント",
  "Under a minute": "1分未満",
  "{minutes} min": "{minutes}分",
  "{hours} h {minutes} min": "{hours}時間{minutes}分",
  "{hours} h": "{hours}時間",
  "Under 1 MB": "1MB未満",
  "{count} part": {
    "other": "{count}パート"
  },
  "{count} recording": {
    "other": "{count}件の録画"
  },
  "data file|Event details": "イベントの詳細",
  "Every event's title, date, place, link and settings": "各イベントのタイトル、日付、場所、リンク、設定",
  "Guests and registrations": "ゲストと登録",
  "Names, emails, how each guest joined and what they watched": "名前、メールアドレス、各ゲストの参加方法と視聴内容",
  "Guestbook messages": "ゲストブックのメッセージ",
  "Every message with its event, name and time": "すべてのメッセージ（イベント、名前、時刻付き）",
  "Viewer counts": "視聴者数",
  "Live and replay viewers for each recording": "イベントごとのライブ配信と録画の視聴者数",
  "Sales and donations": "売上と寄付",
  "Tickets, paid downloads and donations, with amounts and dates": "チケット、有料ダウンロード、寄付（金額と日付付き）",
  "This recording belongs to another account.": "この録画は別のアカウントのものです。",
  "We couldn't find this recording. It may have been deleted.": "この録画が見つかりませんでした。削除された可能性があります。",
  "Downloads are temporarily unavailable. Please try again in a few minutes.": "ダウンロードは一時的にご利用いただけません。数分後にもう一度お試しください。",
  "Could not reach EventLive. Check your internet connection and try again.": "EventLiveに接続できませんでした。インターネット接続を確認して、もう一度お試しください。",
  "Ready to download": "ダウンロードの準備ができました",
  "{count} recording is being prepared": {
    "other": "{count}件の録画を準備中です"
  },
  "Download this one when one of them is ready.": "いずれかの準備が終わってから、この録画をダウンロードしてください。",
  "Could not load your recordings.": "録画を読み込めませんでした。",
  "Couldn't download the file": "ファイルをダウンロードできませんでした",
  "Still preparing. Long recordings take a while; you can leave this page and come back.": "まだ準備中です。長い録画は時間がかかります。このページを離れて、あとで戻ってきても大丈夫です。",
  "Joining {parts} parts into one MP4. This usually takes a few minutes.": "{parts}パートを1つのMP4に結合しています。通常は数分かかります。",
  "Preparing the MP4. This usually takes a few minutes.": "MP4を準備しています。通常は数分かかります。",
  "This is taking much longer than usual. Try again, or contact support.": "通常よりかなり時間がかかっています。もう一度お試しいただくか、サポートにお問い合わせください。",
  "Couldn't prepare the download. Try again.": "ダウンロードを準備できませんでした。もう一度お試しください。",
  "In the Secure Archive, so it can't be downloaded. Restore it to download it again, or delete it.": "安全なアーカイブに保管されているため、ダウンロードできません。復元すると再びダウンロードできます。削除することもできます。",
  "In the Secure Archive, so it can't be downloaded. You can delete it.": "安全なアーカイブに保管されているため、ダウンロードできません。削除することはできます。",
  "Restore {title}": "「{title}」を復元",
  "Delete {title}": "「{title}」を削除",
  "Download": "ダウンロード",
  "Preparing…": "準備中…",
  "Preparing {title}": "「{title}」を準備中",
  "Try again: {title}": "もう一度試す：{title}",
  "Download {title}": "「{title}」をダウンロード",
  "Guestbook PDF · {count} message": {
    "other": "ゲストブックのPDF · メッセージ{count}件"
  },
  "Download the guestbook of {title} as a PDF": "「{title}」のゲストブックをPDFでダウンロード",
  "Download {title} (CSV)": "「{title}」をダウンロード（CSV）",
  "Deleted": "削除しました",
  "Couldn't delete it": "削除できませんでした",
  "Delete “{title}”?": "「{title}」を削除しますか？",
  "The event, its recording, guest list and guestbook are deleted for good. This can't be undone.": "イベントとその録画、ゲストリスト、ゲストブックが完全に削除されます。この操作は取り消せません。",
  "Delete event": "イベントを削除",
  "Loading your recordings…": "録画を読み込み中…",
  "one MP4 file each": "録画ごとに1つのMP4ファイル",
  "loading more…": "さらに読み込み中…",
  "Download everything": "すべてダウンロード",
  "Your recordings are yours. Download any of them, any time, free.": "録画はあなたのものです。どの録画も、いつでも無料でダウンロードできます。",
  "Give a family or a couple their video, or keep your own archive.": "ご家族や新郎新婦に動画をお渡ししたり、ご自身のアーカイブとして保管したりできます。",
  "Download everything is for business accounts. To download a video, open its event and choose Download & View Stats.": "「すべてダウンロード」はビジネスアカウント向けの機能です。動画をダウンロードするには、そのイベントを開いて「ダウンロード・統計を見る」を選んでください。",
  "Recordings": "録画",
  "Couldn't load your recordings": "録画を読み込めませんでした",
  "No recordings yet": "録画はまだありません",
  "When you stream an event or upload a video, it shows up here, ready to download.": "イベントを配信したり動画をアップロードしたりすると、ここに表示され、すぐにダウンロードできます。",
  "Search for a recording": "録画を検索",
  "Search recordings by title, place or date": "タイトル、場所、日付で録画を検索",
  "Clear search": "検索をクリア",
  "No recordings match “{query}”.": "「{query}」に一致する録画はありません。",
  "Show {count} more": "さらに{count}件を表示",
  "{count} recording found.": {
    "other": "{count}件の録画が見つかりました。"
  },
  "Each MP4 joins every live session and upload in order, in the best quality we keep.": "各MP4には、すべてのライブ配信とアップロードが順番につなげられ、保存している最高画質で収録されます。",
  "Long recordings are big files, so use a fast connection.": "長い録画はファイルサイズが大きいため、高速な回線をご利用ください。",
  "It opens in your browser to save. Long recordings are big files: a computer on Wi-Fi is quickest.": "ブラウザで開いて保存します。長い録画はファイルサイズが大きいため、Wi-Fiに接続したパソコンがいちばん早く保存できます。",
  "Your data": "あなたのデータ",
  "Spreadsheets for Excel, Numbers or Google Sheets, covering every event in your account": "アカウント内のすべてのイベントをまとめた、Excel、Numbers、Googleスプレッドシート用の表計算ファイル",
  "One page with your events that anyone with the link can watch, and your ticketed events, newest first.": "リンクを知っていれば誰でも視聴できるイベントと、チケット制のイベントを、新しい順に1ページにまとめて表示します。",
  "Your Video Wall link": "あなたのビデオウォールのリンク",
  "Video Wall link": "ビデオウォールのリンク",
  "Copy Video Wall link": "ビデオウォールのリンクをコピー",
  "Open Video Wall": "ビデオウォールを開く",
  "Embed on your website": "ウェブサイトに埋め込む",
  "Paste the code into your website's HTML or embed block.": "コードをウェブサイトのHTMLまたは埋め込みブロックに貼り付けてください。",
  "Code type": "コードの種類",
  "Script (recommended)": "スクリプト（推奨）",
  "The wall grows to fit all your events instead of scrolling inside a box.": "枠内でスクロールするのではなく、すべてのイベントが収まるようにウォールが広がります。",
  "Simple iframe (no script)": "シンプルなiframe（スクリプトなし）",
  "For site builders that remove scripts. The wall scrolls inside the space your page gives it.": "スクリプトを削除してしまうサイトビルダー向けです。ウォールは、ページ内で割り当てられたスペースの中でスクロールします。",
  "Copy embed code": "埋め込みコードをコピー",
  "Embed code copied": "埋め込みコードをコピーしました",
  "Paste it into your website's HTML.": "ウェブサイトのHTMLに貼り付けてください。"
}
